var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoPrint(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.75 1.5C7.06 1.5 6.5 2.06 6.5 2.75V5H15V2.75C15 2.06 14.44 1.5 13.75 1.5H7.75ZM16.5 5V2.75C16.5 1.231 15.27 0 13.75 0H7.75C6.23 0 5 1.231 5 2.75V5H2.75C1.23 5 0 6.231 0 7.75V15.75C0 17.269 1.23 18.5 2.75 18.5H5V18.75C5 20.269 6.23 21.5 7.75 21.5H13.75C15.27 21.5 16.5 20.269 16.5 18.75V18.5H18.75C20.27 18.5 21.5 17.269 21.5 15.75V7.75C21.5 6.231 20.27 5 18.75 5H16.5ZM16.5 17H18.75C19.44 17 20 16.44 20 15.75V7.75C20 7.06 19.44 6.5 18.75 6.5H2.75C2.06 6.5 1.5 7.06 1.5 7.75V15.75C1.5 16.44 2.06 17 2.75 17H5V14.5H4.75C4.34 14.5 4 14.164 4 13.75C4 13.336 4.34 13 4.75 13H16.75C17.16 13 17.5 13.336 17.5 13.75C17.5 14.164 17.16 14.5 16.75 14.5H16.5V17ZM15 14.5H6.5V18.75C6.5 19.44 7.06 20 7.75 20H13.75C14.44 20 15 19.44 15 18.75V14.5ZM14 9.75C14 9.336 14.34 9 14.75 9H15.75C16.16 9 16.5 9.336 16.5 9.75C16.5 10.164 16.16 10.5 15.75 10.5H14.75C14.34 10.5 14 10.164 14 9.75Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPrint);
export default __webpack_public_path__ + "static/media/ico-print.8493a844.svg";
export { ForwardRef as ReactComponent };